import React, {useState, useEffect, useContext} from 'react';
import './Fermate.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
    DataGridPremium
} from '@mui/x-data-grid-premium';
import ManageFermateDialog from './ManageFermateDialog';
import DeleteFermateDialog from './DeleteFermateDialog';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, /* getPois, */ getFermate) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {
                getFermate();
            }} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function Fermate(props) {
    const auth = useContext(AuthContext);
    const { fermate, setFermate } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();
    const [loading, setLoading] = useState(true);
    const [fermateLoading, setFermateLoading] = useState(true);

    const [openManageFermateDialog, setOpenManageFermateDialog] = useState(false);
    const [openDeleteFermateDialog, setOpenDeleteFermateDialog] = useState(false);

    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageFermateDialog, /* getPois, */ getFermate), renderCell: (params) => ActionCell(params, handleOpenManageFermateDialog, handleOpenDeleteFermateDialog)},
        {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Id Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S},
        {field: 'navilens', headerClassName: 'header-cell navilens', headerName: 'Navilens', type: 'string', width: 150, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'nome', headerClassName: 'header-cell nome', headerName: 'Nome Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
    ]

    useEffect(() => {
        if(!fermate.length){
            getFermate();
        }else{
            setFermateLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getFermate();
        }
    }, [props.city])

    const getFermate = async() => {
        try {
            setLoading(true);
            setFermateLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-fermate',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setFermate(response.data.dataToReturn);
            //setRows(response.data.dataToReturn);
            setFermateLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setFermateLoading(false);
            setLoading(false);
        }
    }

    const handleOpenManageFermateDialog = (action) => {
        setOpenManageFermateDialog(action)
    }
    const handleCloseManageFermateDialog = () => {
        setOpenManageFermateDialog(false);
    }

    const handleOpenDeleteFermateDialog = () => {
        setOpenDeleteFermateDialog(true);
    }   
    const handleCloseDeleteFermateDialog = () => {
        setOpenDeleteFermateDialog(false);
    }

    return (
        <div className='component-container fermate'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={fermate}
                        columns={columns}
                        className="fermate-table"
                        loading={fermateLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        disablePivoting
                        showToolbar
                        slotProps={{
                            toolbar: { 
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { fileName: `fermate_${props.city}_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                                excelOptions: { fileName: `fermate_${props.city}_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`}
                            }
                        }}
                    />
                </ThemeProvider>
            </div>
            <ManageFermateDialog {...{
                openManageFermateDialog,
                handleCloseManageFermateDialog,
                lastCellData,
                getFermate,
                city: props.city
            }}/>
            <DeleteFermateDialog {...{
                openDeleteFermateDialog,
                handleCloseDeleteFermateDialog,
                lastCellData,
                getFermate
            }}/>
        </div>
    )
}

export default Fermate